
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(2580|3591|7413)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
